<template>
  <div class="provider-categories">
      <div class="category-icon" :style="categoryIconStyle"></div>
      <div class="categories-text" :title="categoriesTooltip">
        {{ categoriesText() }}
      </div>
  </div>
</template>

<style scoped>
  .provider-categories {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    padding: 0 8px;
    margin-right: 16px;
    border-radius: 4px;
    color: #646a70;
    border: 1px solid #EAEDEF;
    background-color: white;
    height: 100%;
  }

  .category-icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    filter: invert(41%) sepia(12%) saturate(243%) hue-rotate(169deg) brightness(96%) contrast(94%);
  }
  .categories-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>

<script>
import { mapState } from 'vuex';

export default {
  name: 'provider-categories',
  props: {
    benefitCategories: {
      type: Array,
      required: true,
    },
  },
  methods: {
    categoriesText() {
      const categoryNames = this.benefitCategories.map((category) => {
        const catL10n = category.categoryL10n.find((L10n) => L10n.languageCode === this.locale);
        if (catL10n != null) {
          return catL10n.name;
        }
        return category.name;
      });
      return categoryNames.join(', ');
    },
  },
  computed: {
    ...mapState({
      categories: (state) => state.category.list,
      locale: (state) => state.config.locale,
    }),
    categoryIconStyle() {
      const firstCategory = this.benefitCategories[0];
      const category = this.categories.find((item) => item.name === firstCategory.name);
      const SVG_ICON_INDEX = 5;
      return `background-image: url("${category.icon[SVG_ICON_INDEX].url}")`;
    },
    categoriesTooltip() {
      const categoryText = this.categoriesText();
      if (categoryText.length > 35) {
        return categoryText;
      }
      return '';
    },
  },
};

</script>
